import useSelectLoyaltyOfferKeyByTrim from './useSelectLoyaltyOfferKeyByTrim';
import { getBuildPriceSummaryPath, getTrimPaymentRequestObject } from '../../apiHooks/utils';
import { primaryCalculatorId, selectPaymentOptions } from '../reducers/financialCalculators';
import { selectCurrentVehicle } from '../reducers/currentVehicle';
import { useApiUrl, useAppName, useLanguage, usePageState, useSettings, useUserOrDefaultProvince, } from '../../utils/sitecoreContext';
import { useAppSelector } from '../utils';
import { useGetBuildPriceSummaryQuery } from '../apis/hondaRestApi';
const useFetchSummary = (vehicle, calculatorId) => {
    var _a;
    const { defaultProvince } = useSettings();
    const provinceCode = useUserOrDefaultProvince();
    const appName = useAppName();
    const pageState = usePageState();
    const apiUrl = useApiUrl();
    const languageCode = useLanguage();
    const apiPath = getBuildPriceSummaryPath(appName, pageState);
    const url = `${apiUrl}${apiPath}`;
    const { paymentFrequency, paymentMethod, termAndRate, includeFees, overriddenIsSellingProvince, downPaymentAmount, tradeInValueAmount, tradeInOwingAmount, leaseAdditionalAnnualKm, leaseAnnualKmAllowance, incentiveOfferIds, warrantyAmount, loyaltyOfferKey: loyaltyKey, } = useAppSelector(state => selectPaymentOptions(state, calculatorId));
    const selectLoyaltyOfferKeyByTrim = useSelectLoyaltyOfferKeyByTrim(loyaltyKey, calculatorId === primaryCalculatorId);
    const loyaltyOfferKey = selectLoyaltyOfferKeyByTrim((_a = vehicle.trimKey) !== null && _a !== void 0 ? _a : '');
    const body = getTrimPaymentRequestObject({
        appName,
        defaultProvince,
        downPaymentAmount,
        incentiveOfferIds,
        includeFees,
        leaseAdditionalAnnualKm,
        leaseAnnualKmAllowance,
        loyaltyOfferKey,
        overriddenIsSellingProvince: !!overriddenIsSellingProvince,
        payload: vehicle,
        paymentFrequency,
        paymentMethod,
        provinceCode,
        termAndRate,
        tradeInOwingAmount,
        tradeInValueAmount,
        warrantyAmount,
    });
    const isPayloadValid = !!(body.trimKey &&
        body.transmissionKey &&
        body.modelKey &&
        body.modelYear &&
        body.exteriorColorKey);
    const { data, isFetching, isLoading, error } = useGetBuildPriceSummaryQuery({
        url,
        body,
        languageCode,
    }, { skip: !isPayloadValid });
    return {
        summary: data === null || data === void 0 ? void 0 : data.transformedData,
        response: data === null || data === void 0 ? void 0 : data.originalResponse,
        isFetching,
        isLoading,
        error,
    };
};
export const useFetchCurrentVehicleFinancialCalculatorSummary = (calculatorId) => {
    const { trimKey, transmissionKey, exteriorColorKey, interiorColorKey, accessoryKeys, protectionKeys, protectionAddOnKeys, modelKey, modelYear, } = useAppSelector(selectCurrentVehicle);
    return useFetchSummary({
        trimKey,
        modelKey,
        modelYear,
        transmissionKey,
        exteriorColorKey,
        interiorColorKey,
        accessories: Array.isArray(accessoryKeys) ? accessoryKeys : [],
        protections: Array.isArray(protectionKeys) ? protectionKeys : [],
        protectionAddOns: Array.isArray(protectionAddOnKeys) ? protectionAddOnKeys : [],
    }, calculatorId);
};
export default useFetchCurrentVehicleFinancialCalculatorSummary;
